module.exports = [{
      plugin: require('/Users/raul/github/using-gatsby-mdx-remark-images/node_modules/gatsby-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"/Users/raul/github/using-gatsby-mdx-remark-images/src/components/Layout.jsx"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":1440}}]},
    }]
